import gql from 'graphql-tag'
import articleFields from './fragments/article-fields.gql'
import { PUBLISHED_POST_STATES } from '~/constants/content'
import type { QueryBuilder } from '@/models/graphql'

const buildArticlesByTagsQuery: QueryBuilder = ({
  statuses = PUBLISHED_POST_STATES,
  operator = 'AND',
}) => {
  return gql`
    query getArticlesByTag(
    $tags: [String]
    $first: Int
    $excluded: [ID]
    ) {
      articles: memberships(
        first: $first
        where: {
          stati: [${statuses}]
          notIn: $excluded,
          taxQuery: {
            relation: AND
            taxArray: [
              {
                terms: $tags
                taxonomy: TAG
                operator: ${operator}
                field: SLUG
              },
              {
                terms: ["public"]
                taxonomy: CATEGORY
                operator: NOT_IN
                field: SLUG
              }
            ]
          }
        }
      ) {
        nodes {
          ... articleFields
          memberships {
            thumbnailSquare {
              node {
                sourceUrl
              }
            }
          }
        }
      }
    }
    ${articleFields}
  `
}
export default buildArticlesByTagsQuery
